import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { TrailerProduct } from "Store/interfaces/products/checkout/riskProducts/TrailerProduct";
import React from "react";
import { ProductDetail } from "../../interface";

export const trailerDetailsList = (
  product: TrailerProduct,
): ProductDetail[] => [
  {
    name: "deductible",
    value: (
      <DeductibleValue
        value={product.priceSpecifications.deductible.code ?? "??"}
      />
    ),
  },
  {
    name: "coverageAmount",
    value: <NumberValue value={product.coverageAmount} type={VALUE_TYPE.NOK} />,
  },
  {
    name: "damageRecentYears",
    value: product.damageCountRecentYears ?? 0,
  },
  {
    name: "yearOfLastDamage",
    value: product.yearOfLastDamage,
    hidden: product.damageCountRecentYears === 0,
  },
];
